export default "__VITE_ASSET__BaLc$KLv__"